export default __webpack_public_path__ + "static/media/Electricity_09.75eeb47d.png";